import axios from 'axios';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useQuery from 'Helpers/hooks/useQuery';
import {
  cidWithPrefix,
  GetAPIBaseURL,
  GetToken,
  GetStorage,
  INSIGHT_TOKEN_COOKIE_OPTIONS,
} from 'Helpers';
import { API_GENERATE_TOKEN } from 'Config/api';
import PageAccessDenied from 'Screens/PageAccessDenied';
import { UID, PATH_NAME } from 'Config/constants';

const SsoCallback = () => {
  const query = useQuery();
  const history = useHistory();
  const userId = GetStorage(UID)?.attr;
  const pathName = GetStorage(PATH_NAME)?.attr || '/'
  const [isAccesDenided, setAccessDenied] = useState(false);

  useEffect(() => {
    const getToken = async () => {
      const cookies = new Cookies();

      try {
        const response = await axios({
          method: 'POST',
          baseURL: GetAPIBaseURL(),
          url: API_GENERATE_TOKEN,
          headers: {
            Accept: 'application/json',
            Authorization: GetToken(),
          },
          data: {
            user_id: userId,
            code: query.get('code'),
            company_id: cidWithPrefix('enc'),
            source: cookies.get('isEmail') ? 'email' : ''
          },
        });

        if (response?.status === 200) {
          cookies.set(
            'insight_token',
            `Bearer ${response?.data?.insight_token}`,
            INSIGHT_TOKEN_COOKIE_OPTIONS
          );

          cookies.remove('isEmail', { path: '/'});
          
          history.push(pathName);
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          setAccessDenied(true);
        }
      }
    };

    getToken();
  }, []);
  return <>{isAccesDenided && <PageAccessDenied />}</>;
};

export default SsoCallback;
